module.exports = __webpack_public_path__ + "static/Edit.6a521a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Edit.png
// module id = ./src/images/Edit.png
// module chunks = 4016850265702045000